import React from "react";
import { ModalProps, Modal } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { ICompany, ICompanyFormData } from "../../models/ICompany";
import CompanyForm from "./CompanyForm";
import { useCreateCompanyHook } from "../../data/companies/useCreateCompany";

interface AddCompanyModalProps extends ModalProps {
    onSuccess: (newCompany: ICompany) => void;
    onCancel: () => void;
};

const AddCompanyModal: React.FC<AddCompanyModalProps> = ({
    onSuccess,
    onCancel,
    ...modalProps
}) => {
    const { t } = useTranslation();
    const { create, creating } = useCreateCompanyHook();

    const texts = {
        addCompany: t("Lisää yritys"),
        save: t("Tallenna")
    };

    const _onSubmit = async (values: ICompanyFormData) => {
        const result = await create(values);
        if (result.isSuccess) {
            onSuccess(result.value);
        };
    };


    return (
        <Modal {...modalProps}>
            <Modal.Content>
                <h3> {texts.addCompany} </h3>
                <CompanyForm
                    onSubmit={_onSubmit}
                    onCancel={onCancel}
                    loading={creating}

                />
            </Modal.Content>
        </Modal>
    );
};


export default AddCompanyModal;
